import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChipsComponent } from '../chips/chips.component';

@Component({
  selector: 'common-rate-advanced-selector',
  imports: [FormsModule, ChipsComponent],
  templateUrl: './rate-advanced-selector.component.html',
  styleUrl: './rate-advanced-selector.component.scss',
})
export class RateAdvancedSelectorComponent implements OnInit {
  @Input() options: any[];
  @Input() withSearch: boolean;
  @Input() placeholder: string;
  @Input() isCommodity: boolean;
  @Output() applyFilter = new EventEmitter();

  searchKey: string;
  filteredOptions: any[] = [];

  selectAll(event: Event) {
    this.options.forEach(
      (option) =>
        (option.selected = (event.target as HTMLInputElement).checked),
    );
  }

  ngOnInit() {
    this.filteredOptions = this.options;
  }

  updateSelectAll() {
    const allSelected = this.options.every((option) => option.selected),
      selectAllCheckbox = document.querySelector(
        'input[type="checkbox"]:first-of-type',
      ) as HTMLInputElement;
    selectAllCheckbox.checked = allSelected;
  }

  isAllSelected(): boolean {
    return (
      this.options?.length > 0 &&
      this.options?.every((option) => option.selected)
    );
  }

  removeOption(option: any) {
    option.selected = false;
    this.updateSelectAll();
  }

  applyFilters(): void {
    this.applyFilter.emit();
  }

  clearAll(): void {
    this.options?.forEach((option) => (option.selected = false));
  }

  onChangeKey(value: string) {
    this.searchKey = value;
    this.filterOptions();
  }

  filterOptions() {
    if (!this.searchKey) {
      this.filteredOptions = this.options;
      return;
    }

    const lowerCaseSearchKey = this.searchKey.toLowerCase();

    this.filteredOptions = this.options?.filter((option) => {
      const labelMatches = option.label
          .toLowerCase()
          .includes(lowerCaseSearchKey),
        valueMatches = option?.value
          ?.toLowerCase()
          ?.includes(lowerCaseSearchKey),
        keywordMatches = option.keywords?.some((keyword) =>
          keyword.toLowerCase().includes(lowerCaseSearchKey),
        );

      return labelMatches || valueMatches || keywordMatches;
    });
  }
}
